import React from "react"
import { ReactComponent as Type0 } from '../../assets/images/generators/0.svg';
import { ReactComponent as Type1 } from '../../assets/images/generators/1.svg';
import { ReactComponent as Type2 } from '../../assets/images/generators/2.svg';
import { ReactComponent as Type3 } from '../../assets/images/generators/3.svg';
import { ReactComponent as Type4 } from '../../assets/images/generators/4.svg';
import { ReactComponent as Type5 } from '../../assets/images/generators/5.svg';
import { ReactComponent as Type6 } from '../../assets/images/generators/6.svg';
import { ReactComponent as Type9 } from '../../assets/images/generators/9.svg';
import { ReactComponent as Type11 } from '../../assets/images/generators/11.svg';
import { ReactComponent as Type100 } from '../../assets/images/generators/100.svg';
import { ReactComponent as Type101 } from '../../assets/images/generators/101.svg';
import { ReactComponent as Type102 } from '../../assets/images/generators/102.svg';
import { ApparecchioCategoryType } from '../../generated';

interface Props extends React.SVGProps<SVGSVGElement> {
    apparecchioType: ApparecchioCategoryType;
}
export default (props: Props) => {

    switch (props.apparecchioType) {
        case 0:
            return <Type0 {...props} />
        case 1:
            return <Type1 {...props} />
        case 2:
            return <Type2 {...props} />
        case 3:
            return <Type3 {...props} />
        case 4:
            return <Type4 {...props} />
        case 5:
            return <Type5 {...props} />
        case 6:
            return <Type6 {...props} />
        case 9:
            return <Type9 {...props} />
        case 11:
            return <Type11 {...props} />
        case 100:
            return <Type100 {...props} />
        case 101:
            return <Type101 {...props} />
        case 102:
            return <Type102 {...props} />
        default:
            return <Type0 {...props} />
    }
}